import React from 'react';

export interface AppConfig {
  bankCode: string;
  serviceUrl: string;
  avatarUrl: string;

  timesname?: string;

  useHashRouter?: string;
  searchRoute: string;
  contactsSearchRoute: string;
  homeRoute: string;
  atmRoute: string;
  branchRoute: string;

  yellowmapTileUrl: string;
  yellowmapAutocompleteUrl: string;
  yellowmapSystemPartner: string;
  yellowmapApiUrl: string;
  yellowmapApiSessionUrl: string;
  yellowmapApiKey: string;
  yellowmapFrontendKey: string;

  vcardLink: string;
  navigationLink: string;

  baseUrl: string;
  excludeBlz: string;

  if6styles?: boolean;
}

export const ConfigurationContext = React.createContext<AppConfig>({
  bankCode: '',
  serviceUrl: '',
  avatarUrl: '',

  useHashRouter: undefined,
  searchRoute: '/suche/:latitude/:longitude/:query?',
  contactsSearchRoute: '/beratersuche/:query?',
  homeRoute: '/:query?',
  atmRoute: '/geldautomaten/:slug-:objectId(\\d+)',
  branchRoute: '/filialen/:slug-:objectId(\\d+)',

  yellowmapTileUrl: '',
  yellowmapAutocompleteUrl: '',
  yellowmapSystemPartner: '',
  yellowmapApiKey: '',
  yellowmapFrontendKey: '',
  yellowmapApiUrl: '',
  yellowmapApiSessionUrl: '',

  vcardLink: '',
  navigationLink: '',

  baseUrl: '',
  excludeBlz: '',

  if6styles: false,
});
